import {
  Component,
  OnInit,
  ViewEncapsulation,
  Input,
  ViewChild,
  ViewContainerRef,
} from "@angular/core";
import { Color } from "ng2-charts";

import { ZoneComponent } from "@/shared-module/components";
import { StackedChartDatasource } from "@/shared-module/models";
import { DialogService } from "@/shared-module/services";

@Component({
  selector: "app-stackedchart",
  templateUrl: "stackedchart.component.html",
  encapsulation: ViewEncapsulation.None,
})
export class StackedChartComponent implements ZoneComponent, OnInit {
  @ViewChild("template", { static: true }) template;
  @Input() data: StackedChartDatasource;
  @Input() width: number;
  @Input() needpaddingLeft: boolean;
  @Input() isZoom: boolean;
  constructor(
    private viewContainerRef: ViewContainerRef,
    private dialogService: DialogService,
  ) {}

  public lineChartColors: Color[] = [];
  public barChartData: any[] = [];
  public barChartLabels: string[] = [];
  public barChartType = "bar";

  public barChartOptions: any = {
    aspectRatio: 1.5,
    tooltips: {
      callbacks: {
        title: (items, data) => {
          return this.data.xLabels[items[0].index];
        },
        label: (tooltipItem, data) => {
          let label = data.datasets[tooltipItem.datasetIndex].label || "";

          if (label) {
            label += ": ";
          }
          label +=
            this.data.series[tooltipItem.datasetIndex].yValues[
              tooltipItem.index
            ].yLabel;
          return label;
        },
      },
    },
    responsive: true,
    scales: {
      xAxes: [
        {
          stacked: true,
          id: "x-axis-0",
          offset: true,
          gridLines: {
            drawBorder: false,
            display: false,
          },
        },
      ],
      yAxes: [
        {
          stacked: true,
          ticks: {
            callback: (value) => {
              if (this.data.axisY.isPercentage) {
                return value + "%";
              }
              else if (this.data.axisY.unit)
                  return value + " " + this.data.axisY.unit;
              return value;
            },
          },
          id: "y-axis-0",
          gridLines: {
            drawBorder: true,
            borderDash: [2, 5],
            display: true,
          },
        },
      ],
    },
  };

  zoom() {
    this.dialogService.setZoomInfo(this.data.zoomInfo);
  }

  ngOnInit() {
    this.viewContainerRef.createEmbeddedView(this.template);

    if (this.data) {
      this.barChartData = [];
      this.lineChartColors = [];
      this.barChartLabels = [];
      let data = [];
      let ds = {};
      let color = {};

      this.data.xLabels.forEach((v) => {
        this.barChartLabels.push(v);
      });

      this.data.series.forEach((s) => {
        data = [];

        s.yValues.forEach((v) => {
          data.push(v.y);
        });

        // tslint:disable-next-line:object-literal-shorthand
        ds = { data: data, label: s.caption, stack: s.group, barThickness: 40 };
        color = {
          // grey
          backgroundColor: s.color,
          borderColor: s.color,
          pointBackgroundColor: s.color,
          pointBorderColor: s.color,
          pointHoverBackgroundColor: s.color,
          pointHoverBorderColor: s.color,
        };

        this.barChartData.push(ds);
        this.lineChartColors.push(color);
      });
    }
  }
}
